import type {
  Role,
  Permission,
  PermissionCategory,
  RolePermission,
} from "../types/permissions";

export const permissions: Permission[] = [
  {
    id: "1",
    name: "Submission",
    description: "Manage submissions",
    category: "Content",
  },
  {
    id: "2",
    name: "Internal Review",
    description: "Handle internal reviews",
    category: "Review",
  },
  {
    id: "3",
    name: "External Review",
    description: "Manage external reviews",
    category: "Review",
  },
  {
    id: "4",
    name: "Copyediting",
    description: "Edit and copyedit content",
    category: "Editing",
  },
  {
    id: "5",
    name: "Production",
    description: "Handle production tasks",
    category: "Production",
  },
  {
    id: "6",
    name: "User Management",
    description: "Manage users and roles",
    category: "Administration",
  },
  {
    id: "7",
    name: "System Settings",
    description: "Configure system settings",
    category: "Administration",
  },
];

export const permissionCategories: PermissionCategory[] = [
  {
    id: "1",
    name: "Content Management",
    permissions: permissions.filter((p) => p.category === "Content"),
  },
  {
    id: "2",
    name: "Review Process",
    permissions: permissions.filter((p) => p.category === "Review"),
  },
  {
    id: "3",
    name: "Editing",
    permissions: permissions.filter((p) => p.category === "Editing"),
  },
  {
    id: "4",
    name: "Production",
    permissions: permissions.filter((p) => p.category === "Production"),
  },
  {
    id: "5",
    name: "Administration",
    permissions: permissions.filter((p) => p.category === "Administration"),
  },
];

export const mockRolePermissions: RolePermission[] = [
  {
    roleId: "1",
    permissionId: "1",
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: false,
  },
  {
    roleId: "1",
    permissionId: "2",
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: false,
  },
  {
    roleId: "2",
    permissionId: "1",
    canCreate: false,
    canRead: true,
    canUpdate: true,
    canDelete: false,
  },
  {
    roleId: "2",
    permissionId: "4",
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: false,
  },
];

export const roles: Role[] = [
  {
    id: "1",
    title: "Super Admin",
    description:
      "Full access to manage members, billing, and organization-wide settings.",
    managers: 3,
    addLabel: "Add New Manager",
    permissionLevel: "Administrator",
    permissions: mockRolePermissions.filter((rp) => rp.roleId === "1"),
  },
  {
    id: "2",
    title: "IT Developer Admin",
    description:
      "Manages system configurations, integrations, and IT-related settings.",
    managers: 2,
    addLabel: "Add New IT Admin",
    permissionLevel: "Administrator",
    permissions: mockRolePermissions.filter((rp) => rp.roleId === "2"),
  },
  {
    id: "3",
    title: "Integration Admin",
    description: "Handles third-party integrations and system connectivity.",
    managers: 1,
    addLabel: "Add New Integration Admin",
    permissionLevel: "Manager",
    permissions: [],
  },
  {
    id: "4",
    title: "Accounting Admin",
    description: "Manages financial operations, billing, and expense tracking.",
    managers: 2,
    addLabel: "Add New Accounting Admin",
    permissionLevel: "Manager",
    permissions: [],
  },
  {
    id: "5",
    title: "Team Admin",
    description:
      "Oversees team activities, permissions, and internal operations.",
    managers: 2,
    addLabel: "Add New Team Admin",
    permissionLevel: "Manager",
    permissions: [],
  },
];
